import { useApi } from './useApi'

interface ScopeData {
  scopes: string[]
  hasBusinessManage: boolean
  reauthRequired?: boolean
}

export function useGbpScope() {
  const { data, loading, error, refetch } = useApi<ScopeData>('/api/auth/scope-check')
  return { data, loading, error, refetch }
}
